import s from './ProfileWindow.module.scss';
import { Button } from 'components/common/Button';
import { ReactComponent as Exit } from 'images/exit.svg';
import { ReactComponent as Cross } from 'images/cross.svg';
import { FC } from 'react';
import { useAppDispatch } from 'store/hooks';
import { useLocation, useNavigate, useOutletContext } from 'react-router';
import { userLogout } from 'store/features/user/utils';
import {
  useGetUserDataQuery,
  useLogoutMutation,
} from 'store/features/user/user-api';
import { Modal } from 'components/common/Modal/Modal';
import { ReactComponent as Account } from 'images/account.svg';
import { ReactComponent as Arrow } from 'images/arrow.svg';
import { ReactComponent as Filter } from 'images/filter.svg';
import { ReactComponent as Prices } from 'images/prices.svg';
import { ReactComponent as Settings } from 'images/settings.svg';
import { ReactComponent as Problem } from 'images/problem.svg';
import { ReactComponent as Help } from 'images/help.svg';
import { ReactComponent as Privacy } from 'images/privacy.svg';
import { ReactComponent as PersonData } from 'images/personData.svg';
// import { ProfileLayoutContext } from '../ProfileLayout';
import { useTranslation } from 'react-i18next';
import { ModalNavigationContext } from 'components/pages/ConsultantPage/ConsultantPage';
import { useQueryError } from 'lib/hooks/useQueryError';
import { ErrorModal } from 'components/common/ErrorModal/ErrorModal';
import { Loader } from 'components/common/Loader/Loader';

const icons = {
  account: <Account />,
  exit: <Exit />,
  cross: <Cross />,
  arrow: <Arrow className={s.arrow} />,
  filter: <Filter />,
  prices: <Prices />,
  settings: <Settings />,
  problem: <Problem />,
  support: <Help />,
  privacy: <Privacy />,
  personData: <PersonData />,
};

type ProfileProps = {
  // isOpenMenu: boolean;
  // setIsOpenMenu: (value: ToggleAction) => void;
};

export const ProfileWindow: FC<ProfileProps> = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { data: user } = useGetUserDataQuery();

  const email = user ? user.email : 'Your email';
  const userName = user ? user.firstName : 'Your name';

  const [
    logout,
    { isLoading: isLogoutLoading, isError: isLogoutError, error: logoutError },
  ] = useLogoutMutation();

  const { closeRouteModal } = useOutletContext<ModalNavigationContext>();

  const { showError, errorMessage, closeError } = useQueryError(
    isLogoutError,
    logoutError,
  );

  const handleLogout = async () => {
    try {
      await logout().unwrap();
      userLogout(dispatch, navigate);
    } catch {}
  };

  const handleOpenAccount = () => {
    navigate(`${pathname}/account`);
  };
  const handleOpenPersonalization = () => {
    navigate(`${pathname}/personalization`);
  };
  const handleOpenPrices = () => {
    navigate(`${pathname}/prices`);
  };
  const handleOpenSettings = () => {
    navigate(`${pathname}/settings`);
  };
  const handleOpenProblem = () => {
    navigate(`${pathname}/report-problem`);
  };
  const handleOpenSupport = () => {
    navigate(`${pathname}/support`);
  };
  const _handleOpenPrivacy = () => {
    // navigate(`${pathname}/privacy`);
  };
  const _handleOpenPersonData = () => {
    // navigate(`${pathname}/personData`);
  };
  return (
    <Modal onClose={closeRouteModal}>
      <div className={s.container}>
        <header className={s.header}>
          <div className={s['header-icon']}>{userName[0]}</div>

          <div className={s['header-info']}>
            <p className={s['header-text']}>
              {t('profile.hello')}, {userName}
            </p>

            {/* Заглушка: тариф пока не приходит с backend */}
            <span className={s['header-plan']}>Standard</span>
          </div>

          <span className={s['header-mail']}>{email}</span>
        </header>

        <div className={s.content}>
          <Button className={s['content__btn']} onClick={handleOpenAccount}>
            {icons.account}
            {t('profile.account.title')}
            {icons.arrow}
          </Button>

          <Button
            className={s['content__btn']}
            onClick={handleOpenPersonalization}
          >
            {icons.filter}
            {t('profile.personalization.title')}
            {icons.arrow}
          </Button>

          <Button className={s['content__btn']} onClick={handleOpenPrices}>
            {icons.prices}
            {t('profile.pricesAndOperations.title')}
            {icons.arrow}
          </Button>

          <Button className={s['content__btn']} onClick={handleOpenSettings}>
            {icons.settings}
            {t('profile.mainSettings.title')}
            {icons.arrow}
          </Button>
        </div>

        <div className={s.content}>
          <Button className={s['content__btn']} onClick={handleOpenProblem}>
            {icons.problem}
            {t('profile.reportProblem.title')}
          </Button>

          <Button className={s['content__btn']} onClick={handleOpenSupport}>
            {icons.support}
            {t('profile.support.title')}
          </Button>

          <Button className={s['content__btn']}>
            {icons.privacy}
            {t('profile.privacyPolicy')}
          </Button>

          <Button className={s['content__btn']}>
            {icons.personData}
            {t('profile.personalDataProcessing')}
          </Button>

          <Button className={`${s['content__btn']}`} onClick={handleLogout}>
            {icons.exit}
            {t('profile.logout')}
            <span className={s['content__version']}>
              {t('profile.version')} {__APP_VERSION__}
            </span>
          </Button>
        </div>

        {isLogoutLoading && <Loader />}

        {showError && (
          <ErrorModal message={errorMessage} onClose={closeError} />
        )}
      </div>
    </Modal>
  );
};
